<template>
  <n-config-provider :theme-overrides="themeOverrides">
    <n-message-provider>
      <MelonRain />

      <AppHeader
        :is-logged-in="authStore.isAuthenticated"
        :username="authStore.user?.nickname || ''"
        @login="uiStore.openLogin()"
        @register="uiStore.openRegister()"
        @profile="handleEditProfile()"
        @my-quotes="handleMyQuotes(authStore.user?.nickname)"
        @logout="handleLogout()"
      />

      <SideNav />
      <router-view />

      <LoginModal
        :show="uiStore.showLoginModal"
        @update:show="(value) => (uiStore.showLoginModal = value)"
        @switch-to-register="uiStore.openRegister()"
      />
      <RegisterModal
        :show="uiStore.showRegisterModal"
        @update:show="(value) => (uiStore.showRegisterModal = value)"
        @switch-to-login="uiStore.openLogin()"
      />
    </n-message-provider>
  </n-config-provider>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import AppHeader from "./components/AppHeader.vue";
import MelonRain from "./components/MelonRain.vue";
import SideNav from "./components/SideNav.vue";
import LoginModal from "./components/auth/LoginModal.vue";
import RegisterModal from "./components/auth/RegisterModal.vue";
import { useAuthStore } from "./store/auth";
import { useUiStore } from "./store/ui";
import { naiveThemeOverrides as themeOverrides } from "./theme/naiveThemeOverrides";

const router = useRouter();
const authStore = useAuthStore();
const uiStore = useUiStore();

onMounted(() => {
  // Hay token (venimos de una recarga con sesión ya iniciada) pero `user`
  // está vacío porque nunca lo guardamos en localStorage a propósito.
  if (authStore.isAuthenticated && !authStore.user) {
    authStore.fetchUser();
  }
});

// "Mis frases": el feed de citas del usuario (ProfileView.vue, la vista
// que ya existía).
function handleMyQuotes(nickname) {
  router.push({
    name: "profile",
    params: {
      nickname: nickname,
    },
  });
}

// "Mi perfil": vista nueva para editar los datos del usuario.
function handleEditProfile() {
  router.push({ name: "edit-profile" });
}

function handleLogout() {
  authStore.logout();
  router.push({ name: "home" });
}
</script>